import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useAppId } from '../../context/AppIdContext';
import Header from '../../component/header';
import LiveVotingUser from './liveVotingUser';

const BASE_URL = process.env.REACT_APP_BASE_URL;

const ChangeResponsibility = () => {
    const navigate = useNavigate();
    const {
        appId,
        language,
        userId,
        mobileNo,
        userName: currentUserName,
        userType: currentUserType,
        vidhanSabhaNo,
        vidhanSabhaName,
        logout,
        setAppId,
        setUserName,
        setUserPhoto,
        setUserId,
        setTotalVoters,
        setVidhanSabhaNo,
        setVidhanSabhaName,
        setCandidateNo,
        setCandidateName,
        setPartyShortName,
        setPartyFullName,
        setPartyLogoPng,
        setPartyLogoJpg,
        setSlipMessage,
        setSmsSlipMessage,
        setOfflineStatus,
        setOfflineDbUrl,
        setOfflineVer,
        setSplaceUrl,
        setAppLink,
        setVideoLink,
        setAppVer,
        setBoothNo,
        setTempStatus,
        setPopupStatus,
        setPopupUrl,
        setUserType,
        setIsAuthenticated,
        // Add these
        setCallCenter,
        setPrachar,
        setAacharSahita,
        setLiveVoting,
        setSleepSend,
        setMetaWtsp,
        setWhtspApi,
        setAi,
        setAppClose,
        setWtspDeviceId
    } = useAppId();

    // State
    const [groupedUsers, setGroupedUsers] = useState({});
    const [loading, setLoading] = useState(true);
    const [switching, setSwitching] = useState(false);
    const [error, setError] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [selectedUser, setSelectedUser] = useState(null);

    const lang = language || 'en';

    // Translation dictionary
    const t = {
        en: {
            title: "Change Responsibility",
            subtitle: "Switch between different wards and roles",
            selectRole: "Select New Responsibility",
            currentRole: "Current Role",
            newRole: "New Role",
            switchRole: "Switch Responsibility",
            switching: "Switching...",
            back: "Back",
            dashboard: "Dashboard",
            admin: "Admin",
            subAdmin: "Sub Admin",
            volunteer: "Volunteer",
            boothPramukh: "Booth Pramukh",
            shaktiPramukh: "Shakti Kendra Pramukh",
            roleChanged: "Responsibility changed successfully!",
            sameRole: "You are already using this responsibility",
            logoutAndLogin: "Please login again to see changes",
            loading: "Loading available responsibilities...",
            noUsers: "No other responsibilities available for this mobile number",
            vidhanSabha: "Ward",
            wardNo: "Ward No",
            selectPrompt: "Choose a ward and role to manage.",
            warCaptain: "War Captain",
            boothCaptain: "Booth Captain",
            liveVottingUser: "Live Voting User",
            callSurveyUser: "Call Survey User",
            voterCaptain: "Voter Captain"
        },
        hi: {
            title: "जिम्मेदारी बदलें",
            subtitle: "विभिन्न वार्डों और भूमिकाओं के बीच स्विच करें",
            selectRole: "नई जिम्मेदारी चुनें",
            currentRole: "वर्तमान भूमिका",
            newRole: "नई भूमिका",
            switchRole: "जिम्मेदारी बदलें",
            switching: "बदला जा रहा है...",
            back: "वापस",
            dashboard: "डैशबोर्ड",
            admin: "एडमिन",
            subAdmin: "सब एडमिन",
            volunteer: "कार्यकर्ता",
            boothPramukh: "बूथ प्रमुख",
            shaktiPramukh: "शक्ति केंद्र प्रमुख",
            roleChanged: "जिम्मेदारी सफलतापूर्वक बदली गई!",
            sameRole: "आप पहले से ही इस जिम्मेदारी का उपयोग कर रहे हैं",
            logoutAndLogin: "परिवर्तन देखने के लिए कृपया फिर से लॉगिन करें",
            loading: "उपलब्ध जिम्मेदारियां लोड हो रही हैं...",
            noUsers: "इस मोबाइल नंबर के लिए कोई अन्य जिम्मेदारी उपलब्ध नहीं है",
            vidhanSabha: "वार्ड",
            wardNo: "वार्ड नंबर",
            selectPrompt: "प्रबंधित करने के लिए एक वार्ड और भूमिका चुनें।",
            warCaptain: "वॉर कैप्टन",
            boothCaptain: "बूथ कैप्टन",
            liveVottingUser: "लाइव वोटिंग उपयोगकर्ता",
            callSurveyUser: "कॉल सर्वे उपयोगकर्ता",
            voterCaptain: "वोटर कैप्टन"
        },
        gu: {
            title: "જવાબદારી બદલો",
            subtitle: "વિવિધ વોર્ડ અને ભૂમિકાઓ વચ્ચે સ્વિચ કરો",
            selectRole: "નવી જવાબદારી પસંદ કરો",
            currentRole: "વર્તમાન ભૂમિકા",
            newRole: "નવી ભૂમિકા",
            switchRole: "જવાબદારી બદલો",
            switching: "બદલાઈ રહ્યું છે...",
            back: "પાછા",
            dashboard: "ડેશબોર્ડ",
            admin: "એડમિન",
            subAdmin: "પેટા એડમિન",
            volunteer: "કાર્યકર્તા",
            boothPramukh: "બૂથ પ્રમુખ",
            shaktiPramukh: "શક્તિ કેન્દ્ર પ્રમુખ",
            roleChanged: "જવાબદારી સફળતાપૂર્વક બદલાઈ!",
            sameRole: "તમે પહેલાથી જ આ જવાબદારીનો ઉપયોગ કરી રહ્યા છો",
            logoutAndLogin: "ફેરફારો જોવા માટે કૃપા કરીને ફરીથી લૉગિન કરો",
            loading: "ઉપલબ્ધ જવાબદારીઓ લોડ થઈ રહી છે...",
            noUsers: "આ મોબાઇલ નંબર માટે કોઈ અન્ય જવાબદારી ઉપલબ્ધ નથી",
            vidhanSabha: "વોર્ડ",
            wardNo: "વોર્ડ નંબર",
            selectPrompt: "મેનેજ કરવા માટે વોર્ડ અને ભૂમિકા પસંદ કરો.",
            warCaptain: "વોર કેપ્ટન",
            boothCaptain: "બૂથ કેપ્ટન",
            liveVottingUser: "લાઇવ વોટિંગ યુઝર",
            callSurveyUser: "કોલ સર્વે યુઝર",
            voterCaptain: "વોટર કેપ્ટન"
        }
    };

    const txt = t[lang];

    useEffect(() => {
        if (!mobileNo) {
            setError("Mobile number not found. Please login again.");
            setLoading(false);
            return;
        }
        fetchAllData();
    }, [mobileNo]);

    const fetchAllData = async () => {
        setLoading(true);
        setError('');

        try {
            const response = await axios.post(
                `${BASE_URL}/api/respo`,
                { mobile_no: mobileNo }
            );

            if (response.data.success && response.data.data && response.data.data.result) {
                const allUsers = response.data.data.result;

                // Group users by Ward (vidhansabha_no)
                const grouped = {};

                allUsers.forEach(user => {
                    const wardKey = user.vidhansabha_no;
                    if (!grouped[wardKey]) {
                        grouped[wardKey] = {
                            wardNo: user.vidhansabha_no,
                            wardName: user.vidhansabha_name,
                            users: []
                        };
                    }

                    // Don't add the exact currently active user profile to the list to switch to
                    if (!(user.user_id === parseInt(userId) && parseInt(user.vidhansabha_no) === parseInt(vidhanSabhaNo))) {
                        grouped[wardKey].users.push(user);
                    }
                });

                // Remove wards that ended up with 0 switchable users
                Object.keys(grouped).forEach(key => {
                    if (grouped[key].users.length === 0) {
                        delete grouped[key];
                    }
                });

                setGroupedUsers(grouped);

                if (Object.keys(grouped).length === 0) {
                    setError(txt.noUsers);
                }
            } else {
                setGroupedUsers({});
                setError(txt.noUsers);
            }
        } catch (err) {
            console.error("Error fetching user data:", err);
            setError("Failed to load available roles. Please try again.");
            setGroupedUsers({});
        } finally {
            setLoading(false);
        }
    };

    const handleSwitch = async (selectedUserData) => {
        if (!selectedUserData) return;

        setSwitching(true);
        setError('');
        setSuccessMessage('');

        try {
            const userToSwitch = selectedUserData;

            localStorage.setItem('appId', userToSwitch.app_id);
            localStorage.setItem('userName', userToSwitch.name);
            localStorage.setItem('userId', userToSwitch.user_id);
            localStorage.setItem('totalVoters', userToSwitch.total_voter);
            localStorage.setItem('userType', userToSwitch.user_type);
            localStorage.setItem('boothNo', userToSwitch.booth_no || '');
            localStorage.setItem('tempStatus', userToSwitch.temp_status || '');
            localStorage.setItem('mobileNo', mobileNo);
            localStorage.setItem('vidhanSabhaNo', userToSwitch.vidhansabha_no);
            localStorage.setItem('vidhanSabhaName', userToSwitch.vidhansabha_name);
            localStorage.setItem('candidateNo', userToSwitch.candidate_no);
            localStorage.setItem('candidateName', userToSwitch.candidate_name);
            localStorage.setItem('partyShortName', userToSwitch.party_short_name);
            localStorage.setItem('partyFullName', userToSwitch.party_full_name);
            localStorage.setItem('partyLogoPng', userToSwitch.party_logo_png);
            localStorage.setItem('partyLogoJpg', userToSwitch.party_logo_jpg);
            localStorage.setItem('slipMessage', userToSwitch.slip_message || '');
            localStorage.setItem('smsSlipMessage', userToSwitch.sms_slip_message || '');
            localStorage.setItem('offlineStatus', userToSwitch.offline_status);
            localStorage.setItem('offlineDbUrl', userToSwitch.offline_db_url);
            localStorage.setItem('offlineVer', userToSwitch.offline_ver || '');
            localStorage.setItem('splaceUrl', userToSwitch.splace_url || '');
            localStorage.setItem('appLink', userToSwitch.app_link || '');
            localStorage.setItem('videoLink', userToSwitch.video_link || '');
            localStorage.setItem('appVer', userToSwitch.app_ver || '');
            localStorage.setItem('popupStatus', userToSwitch.popup_status);
            localStorage.setItem('popupUrl', userToSwitch.popup_url || '');
            localStorage.setItem('userData', JSON.stringify(userToSwitch));
            localStorage.setItem(`credential_${userToSwitch.user_id}`, JSON.stringify(userToSwitch));
            localStorage.setItem('callCenter', userToSwitch.call_center);
            localStorage.setItem('prachar', userToSwitch.prachar);
            localStorage.setItem('aacharSahita', userToSwitch.aachar_sahita);
            localStorage.setItem('liveVoting', userToSwitch.live_voting);
            localStorage.setItem('sleepSend', userToSwitch.sleep_send);
            localStorage.setItem('metaWtsp', userToSwitch.meta_wtsp);
            localStorage.setItem('whtspApi', userToSwitch.whtsp_api);
            localStorage.setItem('ai', userToSwitch.AI);
            localStorage.setItem('appClose', userToSwitch.app_close);
            if (userToSwitch.wtsp_device_id) localStorage.setItem('wtspDeviceId', userToSwitch.wtsp_device_id);

            setSuccessMessage(txt.roleChanged);

            setAppId(userToSwitch.app_id);
            setUserPhoto(userToSwitch.photo_path || userToSwitch.photo || null);
            setUserName(userToSwitch.name);
            setUserId(userToSwitch.user_id);
            setTotalVoters(userToSwitch.total_voter);
            setUserType(userToSwitch.user_type);
            setBoothNo(userToSwitch.booth_no || '');
            setTempStatus(userToSwitch.temp_status || '');
            setVidhanSabhaNo(userToSwitch.vidhansabha_no);
            setVidhanSabhaName(userToSwitch.vidhansabha_name);
            setCandidateNo(userToSwitch.candidate_no);
            setCandidateName(userToSwitch.candidate_name);
            setPartyShortName(userToSwitch.party_short_name);
            setPartyFullName(userToSwitch.party_full_name);
            setPartyLogoPng(userToSwitch.party_logo_png);
            setPartyLogoJpg(userToSwitch.party_logo_jpg);
            setSlipMessage(userToSwitch.slip_message || '');
            setSmsSlipMessage(userToSwitch.sms_slip_message || '');
            setOfflineStatus(userToSwitch.offline_status);
            setOfflineDbUrl(userToSwitch.offline_db_url);
            setOfflineVer(userToSwitch.offline_ver || '');
            setSplaceUrl(userToSwitch.splace_url || '');
            setAppLink(userToSwitch.app_link || '');
            setVideoLink(userToSwitch.video_link || '');
            setAppVer(userToSwitch.app_ver || '');
            setPopupStatus(userToSwitch.popup_status);
            setPopupUrl(userToSwitch.popup_url || '');
            // Set new states
            setCallCenter(userToSwitch.call_center);
            setPrachar(userToSwitch.prachar);
            setAacharSahita(userToSwitch.aachar_sahita);
            setLiveVoting(userToSwitch.live_voting);
            setSleepSend(userToSwitch.sleep_send);
            setMetaWtsp(userToSwitch.meta_wtsp);
            setWhtspApi(userToSwitch.whtsp_api);
            setAi(userToSwitch.AI);
            setAppClose(userToSwitch.app_close);
            setWtspDeviceId(userToSwitch.wtsp_device_id || '');

            setTimeout(() => {
                navigate('/');
            }, 1500);

        } catch (err) {
            console.error("Error switching role:", err);
            setError("Failed to switch role. Please try again.");
        } finally {
            setSwitching(false);
        }
    };

    const getUserTypeLabel = (type) => {
        const map = {
            'A': txt.admin,
            'SA': txt.subAdmin,
            'sa': txt.subAdmin,
            'K': txt.volunteer,
            'k': txt.volunteer,
            'BP': txt.boothPramukh,
            'BS': "Sah Booth Pramukh",
            'SP': txt.shaktiPramukh,
            'WP': txt.warCaptain,
            'BC': txt.boothCaptain,
            'LV': txt.liveVottingUser,
            'CL': txt.callSurveyUser,
            'VC': txt.voterCaptain

        };
        return map[type] || type || 'User';
    };

    const hasAnyUsers = Object.keys(groupedUsers).length > 0;

    return (
        <div className="change-responsibility-container">
            <div className="change-wrapper">

                {/* --- LEFT PANEL --- */}
                <div className="info-section">
                    <div className="info-content">

                        {/* Mobile Header (Only visible on mobile) */}
                        <div className="mobile-only w-100" style={{ flexDirection: 'column' }}>
                            <div className="mobile-header-top d-flex">
                                <div className="mobile-avatar">
                                    <img src='/favicon.jpeg' alt="Logo" />
                                </div>
                                <div className="mobile-header-text">
                                    <h2 className="info-title-mobile">{txt.title}</h2>
                                    <p className="system-access-text-mobile">Access Management</p>
                                </div>
                                <div className="mobile-menu-dots" onClick={() => navigate('/')}>
                                    <svg width="24" height="24" fill="none" stroke="#64748b" strokeWidth="2" viewBox="0 0 24 24"><circle cx="12" cy="5" r="1.5" /><circle cx="12" cy="12" r="1.5" /><circle cx="12" cy="19" r="1.5" /></svg>
                                </div>
                            </div>

                            {/* Mobile Combined Card */}
                            <div className="dark-card combined-dark-card">
                                <div className="dark-card-left">
                                    <div className="pin-icon-mobile">
                                        <svg width="20" height="20" fill="none" stroke="#60a5fa" strokeWidth="2" viewBox="0 0 24 24"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
                                    </div>
                                    <div className="dark-card-text-group">
                                        <span className="dark-card-label">ACTIVE WARD</span>
                                        <span className="dark-card-title">{txt.wardNo}: {vidhanSabhaNo || 'N/A'}</span>
                                    </div>
                                </div>
                                <div className="dark-card-right">
                                    <span className="dark-card-label">ROLE</span>
                                    <span className="dark-card-value-blue">{getUserTypeLabel(currentUserType)}</span>
                                </div>
                            </div>
                        </div>

                        {/* Desktop Header & Cards (Only visible on desktop) */}
                        <div className="desktop-only w-100 h-100" style={{ flexDirection: 'column', alignItems: 'center' }}>
                            <div className="info-icon">
                                <img src='/favicon.jpeg' alt="Logo" />
                            </div>

                            <h2 className="info-title">{txt.title}</h2>
                            <p className="system-access-text"></p>

                            {/* Current Ward Card - Desktop */}
                            <div className="dark-card">

                                <span className="dark-card-title">{txt.wardNo}: {vidhanSabhaNo || 'N/A'}</span>
                                <span className="dark-card-sub text-truncate w-100">{vidhanSabhaName || 'N/A'}</span>
                            </div>

                            {/* Current Role Card - Desktop */}
                            <div className="dark-card" style={{ marginBottom: 'auto' }}>
                                <span className="dark-card-label">{txt.currentRole}</span>
                                <span className="dark-card-value-blue">{getUserTypeLabel(currentUserType)}</span>
                            </div>


                        </div>

                    </div>
                </div>

                {/* --- RIGHT PANEL --- */}
                <div className="form-section">
                    <div className="form-header">
                        <h3 className="form-title">{txt.selectRole}</h3>
                        <p className="form-subtitle">{txt.selectPrompt}</p>
                    </div>

                    {loading && (
                        <div className="loading-state">
                            <div className="spinner"></div>
                            <p className="loading-text">{txt.loading}</p>
                        </div>
                    )}

                    {error && !loading && (
                        <div className="error-toast">
                            <span className="error-icon">!</span>
                            <span className="error-text">{error}</span>
                            {error !== txt.noUsers && (
                                <button className="retry-btn-small" onClick={fetchAllData}>Retry</button>
                            )}
                        </div>
                    )}

                    {successMessage && (
                        <div className="success-toast">
                            <span className="success-icon">✓</span>
                            <div className="success-content">
                                <span className="success-text">{successMessage}</span>
                                <span className="logout-note">{txt.logoutAndLogin}</span>
                            </div>
                        </div>
                    )}

                    {/* Combined Ward & Role List */}
                    {!loading && !successMessage && hasAnyUsers && (
                        <>
                            <div className="list-scroller-wrapper">
                                <div className="list-scroller-content">
                                    {Object.values(groupedUsers).map((wardGroup) => (
                                        <div key={`ward-${wardGroup.wardNo}`} className="ward-group-container">

                                            {/* Ward Section Header */}
                                            <div className="ward-section-header">
                                                <div className="ward-badge-pill">
                                                    {wardGroup.wardNo}
                                                </div>
                                                <span className="ward-section-name text-truncate">
                                                    {wardGroup.wardName ? (wardGroup.wardName.includes('Municipal') ? wardGroup.wardName : `${wardGroup.wardName} `) : ''}
                                                </span>
                                            </div>

                                            {/* Users under this Ward */}
                                            <div className="profile-list">
                                                {wardGroup.users.map((user) => (
                                                    <div
                                                        key={user.user_id}
                                                        className={`profile-card ${selectedUser?.user_id === user.user_id ? 'selected' : ''}`}
                                                        onClick={() => setSelectedUser(user)}
                                                    >
                                                        <div className="profile-avatar">
                                                            {user.photo_path ? (
                                                                <img src={user.photo_path} alt={user.name} />
                                                            ) : (
                                                                <span className="avatar-initials">{user.name?.charAt(0) || 'U'}</span>
                                                            )}
                                                        </div>

                                                        <div className="profile-info">
                                                            <div className="profile-header-info">
                                                                <span className="profile-name text-truncate">{user.name}</span>
                                                                <span className={`role-badge-small ${user.user_type === 'A' ? 'admin-badge' : 'sub-admin-badge'}`}>
                                                                    {getUserTypeLabel(user.user_type)}
                                                                </span>
                                                            </div>
                                                            {user.booth_no && (
                                                                <span className="profile-user-name">Booth: {user.booth_no}</span>
                                                            )}
                                                        </div>

                                                        {selectedUser?.user_id === user.user_id && (
                                                            <div className="check-mark">
                                                                <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="3" viewBox="0 0 24 24">
                                                                    <polyline points="20 6 9 17 4 12"></polyline>
                                                                </svg>
                                                            </div>
                                                        )}
                                                    </div>
                                                ))}
                                            </div>

                                        </div>
                                    ))}
                                </div>

                            </div>

                            {/* Desktop Action Buttons */}
                            <div className="action-buttons desktop-only">
                                <button className="back-btn" onClick={() => navigate('/')}>
                                    <span style={{ fontSize: '18px', marginRight: '6px' }}>←</span>
                                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', lineHeight: '1.2' }}>
                                        <span>Back to Dashboard</span>

                                    </div>
                                </button>
                                <button
                                    className="switch-btn"
                                    onClick={() => handleSwitch(selectedUser)}
                                    disabled={!selectedUser || switching}
                                >
                                    {switching ? <div className="loader-small"></div> : txt.switchRole}
                                </button>
                            </div>
                        </>
                    )}

                    {!loading && !successMessage && !hasAnyUsers && !error && (
                        <div className="no-users-state">
                            <div className="no-users-icon">👤</div>
                            <p>{txt.noUsers}</p>
                            <button className="back-dashboard-btn" onClick={() => navigate('/')}>
                                {txt.back}
                            </button>
                        </div>
                    )}
                </div>

                {/* --- MOBILE STICKY BOTTOM BAR --- */}
                {!loading && hasAnyUsers && (
                    <div className="mobile-action-bar mobile-only">
                        <button
                            className="mobile-switch-btn"
                            onClick={() => handleSwitch(selectedUser)}
                            disabled={!selectedUser || switching}
                        >
                            {switching ? <div className="loader-small"></div> : (
                                <>
                                    <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" style={{ marginRight: '8px' }}>
                                        <polyline points="16 3 21 3 21 8"></polyline><line x1="4" y1="20" x2="21" y2="3"></line><polyline points="21 16 21 21 16 21"></polyline><line x1="15" y1="15" x2="21" y2="21"></line><line x1="4" y1="4" x2="9" y2="9"></line>
                                    </svg>
                                    {txt.switchRole}
                                </>
                            )}
                        </button>
                        <div className="mobile-bottom-row">
                            <button className="mobile-secondary-btn" onClick={() => navigate('/')}>
                                <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect></svg>
                                {txt.dashboard}
                            </button>
                            <button className="mobile-secondary-btn" onClick={() => navigate(-1)}>
                                <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg>
                                {txt.back}
                            </button>
                        </div>
                    </div>
                )}
            </div>

            <style jsx>{`
                .change-responsibility-container {
                    width: 100%;
                    min-height: 100vh;
                    background: #f8fafc;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 20px;
                    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
                }

                .change-wrapper {
                    display: flex;
                    width: 100%;
                    max-width: 950px;
                    height: 520px;
                    background: #ffffff;
                    border-radius: 12px;
                    overflow: hidden;
                    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 0 0 1px rgba(0, 0, 0, 0.05);
                }

                /* Display Toggle Classes */
                .mobile-only { display: none !important; }
                .desktop-only { display: flex; }
                .w-100 { width: 100%; }
                .h-100 { height: 100%; }
                .text-truncate { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }

                /* --- LEFT PANEL STYLES (DESKTOP) --- */
                .info-section {
                    width: 360px;
                    background: #111827; 
                    padding: 30px 24px;
                    display: flex;
                    flex-direction: column;
                }

                .info-content {
                    text-align: center;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    height: 100%;
                    width: 100%;
                }

                .info-icon {
                    width: 100px;
                    height: 100px;
                    border-radius: 50%;
                    background: #ffffff;
                    margin: 10px auto 20px;
                    position: relative;
                    box-shadow: -4px -4px 20px rgba(167, 243, 208, 0.3), 4px 4px 20px rgba(96, 165, 250, 0.4);
                }

                .info-icon img {
                    width: 100%; height: 100%; object-fit: cover; border-radius: 50%;
                }

                .info-title {
                    font-size: 24px; font-weight: 700; color: white; margin: 0;
                }

                .system-access-text {
                    font-size: 13px; color: #94a3b8; margin-top: 6px; margin-bottom: 24px;
                }

                .dark-card {
                    background: #1e293b; border: 1px solid #334155; border-radius: 12px;
                    padding: 14px; width: 100%; margin-bottom: 12px;
                    display: flex; flex-direction: column; align-items: center;
                }

                .dark-card-label {
                    font-size: 10px; font-weight: 600; color: #64748b;
                    text-transform: uppercase; letter-spacing: 1px; margin-bottom: 6px;
                }

                .dark-card-title {
                    font-size: 18px; font-weight: 700; color: white; margin-bottom: 4px;
                }

                .dark-card-sub {
                    font-size: 12px; color: #94a3b8; width: 100%; text-align: center;
                }

                .dark-card-value-blue {
                    font-size: 16px; font-weight: 700; color: #60a5fa; 
                    text-transform: uppercase; letter-spacing: 1px;
                }

                .version-text {
                    color: #475569; font-size: 11px; font-style: italic;
                    margin-top: auto; padding-top: 15px;
                }

                /* --- RIGHT PANEL STYLES --- */
                .form-section {
                    flex: 1; padding: 30px 40px; 
                    background: #f8fafc; /* Enhanced Background */
                    display: flex; flex-direction: column;
                }

                .form-header { 
                    margin-bottom: 24px; 
                    padding-bottom: 16px; 
                    border-bottom: 1px solid #e2e8f0; /* Added subtle separator */
                }
                .form-title { font-size: 22px; font-weight: 800; color: #0f172a; margin: 0 0 6px; }
                .form-subtitle { font-size: 14px; color: #64748b; margin: 0; }

                /* Grouped List Wrapper */
                .list-scroller-wrapper {
                    flex: 1; overflow-y: auto; margin-bottom: 20px; padding-right: 8px;
                }
                .list-scroller-content {
                    display: flex; flex-direction: column; gap: 24px;
                }

                /* Ward Section Header */
                .ward-group-container {
                    display: flex; flex-direction: column; gap: 12px;
                }

                .ward-section-header {
                    display: flex; align-items: center; gap: 12px;
                    padding-bottom: 8px; border-bottom: 2px solid #e2e8f0;
                }

                .ward-badge-pill {
                    background: #e0e7ff; color: #3730a3; font-size: 12px;
                    font-weight: 700; padding: 4px 12px; border-radius: 50px;
                    border: 1px solid #c7d2fe;
                }

                .ward-section-name {
                    font-size: 14px; font-weight: 700; color: #1e293b;
                }

                /* Profile Cards */
                .profile-list {
                    display: flex; flex-direction: column; gap: 10px;
                }

                .profile-card {
                    display: flex; align-items: center; padding: 12px 16px;
                    border: 1px solid #e2e8f0; border-radius: 12px; 
                    background: #ffffff; /* Enhanced to pure white */
                    box-shadow: 0 1px 3px rgba(0,0,0,0.02); /* Added subtle shadow */
                    cursor: pointer; transition: all 0.2s ease;
                }
                .profile-card:hover { 
                    border-color: #cbd5e1; 
                    box-shadow: 0 4px 6px rgba(0,0,0,0.04);
                    transform: translateY(-2px);
                }
                .profile-card.selected {
                    background: #eff6ff; border: 1.5px solid #3b82f6;
                    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.15);
                }

                .profile-avatar {
                    width: 44px; height: 44px; border-radius: 50%;
                    background: #f1f5f9; border: 1px solid #e2e8f0;
                    display: flex; align-items: center; justify-content: center;
                    margin-right: 16px; flex-shrink: 0; overflow: hidden;
                }
                .profile-avatar img { width: 100%; height: 100%; object-fit: cover; }
                .avatar-initials { font-size: 18px; font-weight: 700; color: #0f172a; text-transform: uppercase; }

                .profile-info { flex: 1; min-width: 0; }
                .profile-header-info { display: flex; align-items: center; gap: 10px; margin-bottom: 4px; }
                .profile-name { font-size: 15px; font-weight: 700; color: #0f172a; }

                .role-badge-small {
                    font-size: 10px; font-weight: 700; padding: 2px 8px;
                    border-radius: 4px; text-transform: uppercase; white-space: nowrap;
                }
                .admin-badge { background: #e2e8f0; color: #475569; }
                .sub-admin-badge { background: #e0e7ff; color: #1d4ed8; }

                .profile-user-name { display: block; font-size: 12px; color: #64748b; font-weight: 500; }

                .check-mark {
                    width: 24px; height: 24px; border-radius: 50%; 
                    background: linear-gradient(135deg, #3b82f6, #2563eb); color: white;
                    display: flex; align-items: center; justify-content: center; flex-shrink: 0;
                    box-shadow: 0 2px 4px rgba(37, 99, 235, 0.3);
                }

                /* Buttons */
                .action-buttons { display: flex; gap: 16px; margin-top: auto; }
                .back-btn {
                    flex: 0 0 auto; display: flex; align-items: center; padding: 10px 20px;
                    background: #ffffff; color: #475569; 
                    border: 1px solid #e2e8f0; border-radius: 8px;
                    font-size: 13px; font-weight: 600; cursor: pointer; transition: background 0.2s;
                    box-shadow: 0 1px 2px rgba(0,0,0,0.02);
                }
                .back-btn:hover { background: #f1f5f9; }

                .switch-btn {
                    flex: 1; padding: 12px; 
                    background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%); color: white;
                    border: none; border-radius: 8px; font-size: 14px; font-weight: 600;
                    cursor: pointer; transition: all 0.2s ease; display: flex;
                    align-items: center; justify-content: center;
                    box-shadow: 0 4px 6px -1px rgba(37, 99, 235, 0.2);
                }
                .switch-btn:hover:not(:disabled) { 
                    background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
                    box-shadow: 0 6px 12px -2px rgba(37, 99, 235, 0.3);
                    transform: translateY(-1px);
                }
                .switch-btn:disabled { opacity: 0.6; cursor: not-allowed; box-shadow: none; transform: none; }

                /* States */
                .loading-state, .no-users-state { text-align: center; padding: 40px 20px; }
                .spinner { width: 40px; height: 40px; border: 3px solid #e2e8f0; border-top: 3px solid #3b82f6; border-radius: 50%; animation: spin 1s linear infinite; margin: 0 auto 16px; }
                .loader-small { width: 18px; height: 18px; border: 2px solid rgba(255,255,255,0.3); border-top: 2px solid white; border-radius: 50%; animation: spin 0.8s linear infinite; }
                @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
                .loading-text, .no-users-state p { color: #64748b; font-weight: 500; }
                .no-users-icon { font-size: 48px; margin-bottom: 16px; }

                .error-toast, .success-toast { display: flex; align-items: center; gap: 12px; padding: 12px 16px; border-radius: 8px; margin-bottom: 20px; }
                .error-toast { background: #fef2f2; border: 1px solid #fecaca; }
                .success-toast { background: #f0fdf4; border: 1px solid #bbf7d0; }
                .error-icon { width: 24px; height: 24px; background: #ef4444; color: white; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-weight: bold; flex-shrink: 0; }
                .success-icon { width: 24px; height: 24px; background: #10b981; color: white; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-weight: bold; flex-shrink: 0; }
                .error-text { color: #991b1b; font-size: 14px; font-weight: 500; flex: 1; }
                .success-text { color: #166534; font-size: 14px; font-weight: 600; display: block; }
                .logout-note { color: #64748b; font-size: 12px; }
                .retry-btn-small { padding: 6px 12px; background: #ef4444; color: white; border: none; border-radius: 6px; font-size: 12px; cursor: pointer; }

                /* Scrollbar */
                .list-scroller-wrapper::-webkit-scrollbar { width: 6px; }
                .list-scroller-wrapper::-webkit-scrollbar-track { background: transparent; }
                .list-scroller-wrapper::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 4px; }

                /* --- MOBILE RESPONSIVE STYLES --- */
                @media (max-width: 768px) {
                    .change-responsibility-container { padding: 0; background: #f8fafc; align-items: flex-start; }
                    .change-wrapper { flex-direction: column; height: 100vh; border-radius: 0; box-shadow: none; }
                    .desktop-only { display: none !important; }
                    .mobile-only { display: flex !important; }

                    /* Mobile Header */
                    .info-section { width: 100%; padding: 16px 20px; background: #111827; border-bottom-left-radius: 0; border-bottom-right-radius: 0; }
                    .mobile-header-top { align-items: center; gap: 12px; margin-bottom: 20px; width: 100%; }
                    .mobile-avatar { width: 48px; height: 48px; border-radius: 50%; background: white; padding: 2px; }
                    .mobile-avatar img { width: 100%; height: 100%; border-radius: 50%; object-fit: cover; }
                    .mobile-header-text { flex: 1; text-align: left; }
                    .info-title-mobile { font-size: 18px; font-weight: 700; color: white; margin: 0; }
                    .system-access-text-mobile { font-size: 12px; color: #94a3b8; margin: 0; }
                    .mobile-menu-dots { cursor: pointer; }

                    /* Horizontal Dark Card */
                    .combined-dark-card { flex-direction: row !important; justify-content: space-between; align-items: center; padding: 16px; margin-bottom: 0; }
                    .dark-card-left { display: flex; align-items: center; gap: 12px; text-align: left; }
                    .pin-icon-mobile { width: 36px; height: 36px; background: rgba(96, 165, 250, 0.1); border-radius: 8px; align-items: center; justify-content: center; }
                    .dark-card-text-group { display: flex; flex-direction: column; }
                    .dark-card-right { text-align: right; display: flex; flex-direction: column; }

                    /* Body Form Area */
                    .form-section { padding: 24px 20px 140px 20px; background: #f8fafc; overflow-y: auto; }
                    .form-header { margin-bottom: 16px; border-bottom: none; padding-bottom: 0; }
                    .form-title { font-size: 18px; }
                    .list-scroller-wrapper { overflow: visible; margin-bottom: 0; }
                    .version-text-mobile { text-align: center; font-size: 11px; color: #94a3b8; font-style: italic; margin-top: 24px; }

                    /* Sticky Bottom Action Bar */
                    .mobile-action-bar {
                        position: fixed; bottom: 0; left: 0; width: 100%; background: #ffffff;
                        padding: 16px 20px; display: flex; flex-direction: column; gap: 12px;
                        box-shadow: 0 -10px 25px rgba(0,0,0,0.05); z-index: 50; border-top: 1px solid #f1f5f9;
                    }
                    .mobile-switch-btn {
                        width: 100%; padding: 14px; 
                        background: linear-gradient(135deg, #1e3a8a, #172554); color: white;
                        border: none; border-radius: 10px; font-weight: 700; font-size: 15px;
                        display: flex; align-items: center; justify-content: center;
                        box-shadow: 0 4px 10px rgba(30, 58, 138, 0.3);
                    }
                    .mobile-switch-btn:disabled { opacity: 0.7; box-shadow: none; }
                    .mobile-bottom-row { display: flex; gap: 12px; width: 100%; }
                    .mobile-secondary-btn {
                        flex: 1; padding: 12px; background: #ffffff; color: #334155;
                        border: 1px solid #e2e8f0; border-radius: 10px; font-weight: 600; font-size: 13px;
                        display: flex; align-items: center; justify-content: center; gap: 8px;
                        box-shadow: 0 1px 2px rgba(0,0,0,0.02);
                    }
                }
            `}</style>
        </div>
    );
};

export default ChangeResponsibility;